import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'recrewt-primary-bg-layout',
  templateUrl: './primary-bg-layout.component.html',
  styleUrls: ['./primary-bg-layout.component.scss'],
})
export class PrimaryBgLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
